// GtEditor.js — the platform rich text editor. TinyMCE self-hosted, no API key,
// no cloud script, no CDN. Full-ribbon WYSIWYG for the JD and the advert.
//
// Drop-in for the previous editor's interface: value / onChange / placeholder /
// minHeight, so it slots into every place the old headless editor sat.
//
// Self-hosting under CRA: core, model, theme, icons, the skin CSS and every
// plugin are imported so webpack bundles them; skin:false / content_css:false
// stop TinyMCE fetching anything by URL at runtime. Content appearance is set
// through content_style rather than importing content.min.css, because CRA does
// not expose a CSS file's text as a string import without ejecting.

import React, { useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';

// Core, model, theme, icons.
import 'tinymce/tinymce';
import 'tinymce/models/dom/model';
import 'tinymce/themes/silver';
import 'tinymce/icons/default';

// Editor-chrome skin, bundled by webpack (path verified in node_modules).
import 'tinymce/skins/ui/oxide/skin.min.css';

// Plugins named in the toolbar below. Each must be imported to register.
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/link';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/code';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/table';
import 'tinymce/plugins/wordcount';

export default function GtEditor({ value, onChange, placeholder, minHeight = 340, onReady }) { // C1-EMAIL: onReady hands over the editor
  const editorRef = useRef(null);

  return (
    <Editor
      onInit={(evt, editor) => { editorRef.current = editor; if (onReady) onReady(editor); }}
      value={value || ''}
      onEditorChange={(content) => { if (onChange) onChange(content); }}
      licenseKey="gpl"
      init={{
        height: minHeight,
        menubar: false,
        branding: false,
        promotion: false,
        statusbar: true,
        placeholder: placeholder || '',
        skin: false,
        content_css: false,
        content_style:
          'body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,' +
          'Helvetica,Arial,sans-serif;font-size:15px;line-height:1.55;color:#161618;' +
          'padding:8px 10px;}' +
          'a{color:#1FA9B2;}' +
          'h1,h2,h3{color:#161618;}',
        plugins: [
          'advlist', 'autolink', 'lists', 'link', 'charmap', 'preview',
          'searchreplace', 'visualblocks', 'code', 'fullscreen', 'table',
          'wordcount',
        ],
        toolbar:
          'undo redo | blocks | bold italic underline | ' +
          'bullist numlist | link table | ' +
          'alignleft aligncenter alignright | removeformat | searchreplace | ' +
          'visualblocks code preview fullscreen',
        block_formats:
          'Paragraph=p; Heading 1=h1; Heading 2=h2; Heading 3=h3; Quote=blockquote',
      }}
    />
  );
}
